import React from 'react';
import { pxToRem } from '../util';
import { Column, ConfigProvider, Line } from '@ant-design/charts';
import GenderProgressChart from './GenderProgressChart';
import CardHeader from './CardHeader';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';

  const data = [
    {
      label: '25岁以下',
      value: props.charts?.ageDistribution?.under25Total || 0,
    },
    {
      label: '25-30岁',
      value: props.charts?.ageDistribution?.between25And30Total || 0,
    },
    {
      label: '31-35岁',
      value: props.charts?.ageDistribution?.between31And35Total || 0,
    },
    {
      label: '36-40岁',
      value: props.charts?.ageDistribution?.between36And40Total || 0,
    },
    {
      label: '41-50岁',
      value: props.charts?.ageDistribution?.between41And50Total || 0,
    },
    {
      label: '51岁以上',
      value: props.charts?.ageDistribution?.above50Total || 0,
    },
  ];

  // 计算总数，用于求占比
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const config = {
    data,
    xField: 'label',
    yField: 'value',
    label: {
      textBaseline: 'bottom',
      style: {
        fill: '#fff', // 标签颜色
        fontSize: 12,
      },
      // 自定义标签内容
      formatter: (datum) => {
        const percent = ((datum / total) * 100).toFixed(1);
        return `${percent}%`;
      },
    },
    style: {
      maxWidth: 20,
      // 圆角样式
      radiusTopLeft: 10,
      radiusTopRight: 10,
    },
  };

  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: '35vh',
        maxHeight: '35vh',
        overflow: 'hidden',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      {/* <div
        style={{
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          fontSize: pxToRem(18),
        }}
      >
        <span>人群分布情况</span>
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          Crowd distribution
        </span>
      </div> */}
      <CardHeader title="人群分布情况" subtitle="Crowd distribution" />

      <div>
        <div style={{ height: '20vh' }}>
          <ConfigProvider
            common={{
              theme: {
                type: 'dark', // 基于 dark 主题定制
                axis: {
                  labelFill: color,
                },
              },
            }}
          >
            <Column {...config} />
          </ConfigProvider>
        </div>
        <div>
          <GenderProgressChart
            maleValue={props.charts?.otherDistribution?.maleTotal || 0}
            femaleValue={props.charts?.otherDistribution?.femaleTotal || 0}
          />
        </div>
      </div>
    </div>
  );
};
export default Box1;
